// Simple infinite scroll with filter support
(() => {
  // Skip if not on a collection/search page
  if (!document.querySelector('#product-grid') || !document.querySelector('.ajax-infinite-container')) return;
  
  // Config & state
  const isCustomizer = typeof Shopify !== 'undefined' && Shopify.designMode;
  let isLoading = false;
  let currentPage = 1;
  let totalPages = 1;
  let observer = null;
  
  function init() {
    // Get container data
    const container = document.querySelector('.ajax-infinite-container');
    if (!container) return;
    
    currentPage = parseInt(container.dataset.currentPage || 1);
    totalPages = parseInt(container.dataset.totalPages || 1);
    
    // Set up infinite scroll
    setupInfiniteScroll();
    
    // Add pagination inputs to filter forms
    addFilterInputs();
    
    // Set up filter change detection
    setupFilterDetection();
  }
  
  function setupInfiniteScroll() {
    const loadingIcon = document.querySelector('.infinite-scroll-loader');
    if (!loadingIcon) return;
    
    observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !isLoading && currentPage < totalPages) {
          loadNextPage();
        }
      });
    }, {
      rootMargin: '0px 0px 500px 0px',
      threshold: 0.1
    });
    
    observer.observe(loadingIcon);
  }
  
  function addFilterInputs() {
    // Add to filter forms
    document.querySelectorAll('#FacetFiltersForm, #FacetFiltersFormMobile').forEach(form => {
      if (!form.querySelector('input[name="pagination_type"]')) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'pagination_type';
        input.value = 'infinite';
        form.appendChild(input);
      }
      
      if (!form.querySelector('input[name="products_per_load"]')) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'products_per_load';
        input.value = getProductsPerLoad();
        form.appendChild(input);
      }
    });
  }
  
  function setupFilterDetection() {
    // Filter removal links
    document.addEventListener('click', e => {
      if (e.target.closest('facet-remove a')) {
        setTimeout(reinitialize, isCustomizer ? 800 : 500);
      }
    });
    
    // Checkbox changes
    document.addEventListener('change', e => {
      if (e.target.matches('input[type="checkbox"]') && 
          (e.target.closest('.facet-checkbox') || e.target.closest('.mobile-facets__label'))) {
        setTimeout(reinitialize, isCustomizer ? 800 : 500);
      }
    });
    
    // Form submissions
    document.querySelectorAll('#FacetFiltersForm, #FacetFiltersFormMobile').forEach(form => {
      form.addEventListener('submit', () => {
        setTimeout(reinitialize, isCustomizer ? 800 : 500);
      });
    });
    
    // Watch product grid for changes
    const productGrid = document.querySelector('#ProductGridContainer');
    if (productGrid) {
      new MutationObserver((mutations) => {
        const hasChanges = mutations.some(m => 
          m.type === 'childList' && (m.addedNodes.length > 0 || m.removedNodes.length > 0));
        
        if (hasChanges && !isLoading) {
          reinitialize();
        }
      }).observe(productGrid, { childList: true });
    }
    
    // Customizer-specific events
    if (isCustomizer) {
      // For direct checkbox clicks in Customizer
      document.addEventListener('click', e => {
        if (e.target.closest('.facet-checkbox')) {
          setTimeout(reinitialize, 800);
        }
      });
      
      // Shopify section events
      document.addEventListener('shopify:section:load', () => setTimeout(reinitialize, 500));
      document.addEventListener('shopify:section:select', () => setTimeout(reinitialize, 500));
    }
  }
  
  function reinitialize() {
    // Clean up
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    
    // Reset state
    isLoading = false;
    
    // Reinitialize
    init();
  }
  
  function getProductsPerLoad() {
    const container = document.querySelector('.ajax-infinite-container');
    if (container?.dataset.productsPerLoad) {
      return container.dataset.productsPerLoad;
    }
    
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('products_per_load')) {
      return urlParams.get('products_per_load');
    }
    
    return '8';
  }
  
  function loadNextPage() {
    // Get next URL
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    
    params.set('page', currentPage + 1);
    params.set('pagination_type', 'infinite');
    params.set('products_per_load', getProductsPerLoad());
    
    const nextUrl = `${url.pathname}?${params.toString()}`;
    
    // Update state
    isLoading = true;
    
    // Show loader
    const loader = document.querySelector('.infinite-scroll-loader');
    if (loader) loader.style.display = 'block';
    
    // Fetch next page
    fetch(nextUrl)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Find the product grid
        const productGrid = document.querySelector('#product-grid .row');
        if (!productGrid) return;
        
        // Find new products
        let newProducts = [];
        
        // Try several strategies to find products
        const newProductGrid = doc.querySelector('#product-grid .row');
        if (newProductGrid) {
          newProducts = Array.from(newProductGrid.querySelectorAll('.col'));
        }
        
        // If we found products, add them
        if (newProducts.length > 0) {
          // Get existing product handles to avoid duplicates
          const existingHandles = getExistingProductHandles();
          
          // Add new products
          newProducts.forEach(product => {
            const handle = getProductHandle(product);
            if (!handle || !existingHandles.includes(handle)) {
              productGrid.appendChild(product.cloneNode(true));
            }
          });
          
          // Update page counter
          currentPage++;
          
          // Init quickview and swatches if available
          if (typeof initQuickView === 'function') initQuickView();
          if (typeof initColorSwatches === 'function') initColorSwatches();
          
          // Check if we're at the end
          if (currentPage >= totalPages) {
            if (loader) loader.style.display = 'none';
            const noMore = document.querySelector('.no-more-products');
            if (noMore) noMore.style.display = 'block';
          }
        } else {
          // No products found
          if (loader) loader.style.display = 'none';
          const noMore = document.querySelector('.no-more-products');
          if (noMore) noMore.style.display = 'block';
        }
      })
      .catch(error => console.error('Error loading products:', error))
      .finally(() => {
        isLoading = false;
      });
  }
  
  function getExistingProductHandles() {
    const productGrid = document.querySelector('#product-grid .row');
    if (!productGrid) return [];
    
    return Array.from(productGrid.querySelectorAll('.col'))
      .map(getProductHandle)
      .filter(Boolean);
  }
  
  function getProductHandle(element) {
    // Try to get handle from links
    const links = element.querySelectorAll('a[href*="/products/"]');
    for (const link of links) {
      const match = link.href.match(/\/products\/([a-zA-Z0-9-_]+)/);
      if (match && match[1]) return match[1];
    }
    
    // Try data attributes
    const productEl = element.querySelector('[data-product-id], [data-product-handle]');
    if (productEl) {
      return productEl.dataset.productHandle || productEl.dataset.productId;
    }
    
    return null;
  }
  
  // Start on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();